export default __webpack_public_path__ + "static/media/Loader.558ce123.svg";